import { ApprovalFormLevel } from './fieldTypes';

export interface FormApproval {
  formId: number;
  id: number;
  approvalType: string;
  groupedLevelByStatut?: GroupedLevelByStatut[] | null;
  approvalTypeList?: string | null;
  levelCount: number;
  fk_Type: string;
  fk_TypeList?: string | null;
  canDeleted: boolean;
  levelTypeList?: string | null;
  usersList?: string | null;
  status?: Select[] | null;
  usersNotificationList?: SelectItem[] | null;
  usersNotification?: string | null;
  users2List?: Select[] | null;
}

export interface GroupedLevelByStatut {
  statutList: SelectItem[];
  statut?: string;
  statutNames?: string;
  statutIds?: number | null;
  levels?: ApprovalFormLevel[];
}

export interface Select {
  id?: string | null;
  text?: string | null;
}

export interface FormApprovalProcess {
  formId: number;
  activedApproval: boolean;
  approvals: ApprovalForm[];
}

export interface ApprovalForm {
  id: number;
  approvalType?: string;
  fk_TypeName?: string;
  isRespectOrder: boolean;
  canDeleted: boolean;
  approvalFormLevelGrouped?: ApprovalFormLevelGrouped[];
}

export interface ApprovalFormLevelGrouped {
  statutName?: string;
  levelCount: number;
  approvalFormLevel?: ApprovalFormLevel[];
}

export enum ApprovalType {
  All = 'All',
  Departement = 'Departement',
  Society = 'Society',
  Team = 'Team',
  Site = 'Site',
  User = 'User',
}
